import React from "react";
import { useTranslation } from "react-i18next";

import { SelectField } from "@shared/form/SelectField/SelectField";
import { SingleSelectFieldProps } from "@shared/form/SelectField/SelectField.types";

type LanguageSwitcherProps = {
    showLabel?: boolean;
    fullWidth?: boolean;
};

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ showLabel = true, fullWidth = false }) => {
    const { t, i18n } = useTranslation(["common", "pages"]);

    // Extract base language code (browser returns "de-DE", we need "de")
    const currentLanguage = i18n.language?.split("-")[0] || "en";

    const options = [
        { label: t("common:language.de"), value: "de" },
        { label: t("common:language.en"), value: "en" },
        { label: t("common:language.fr"), value: "fr" },
        { label: t("common:language.pl"), value: "pl" },
        { label: t("common:language.ja"), value: "ja" },
        { label: t("common:language.ru"), value: "ru" },
    ];

    const onChange: SingleSelectFieldProps["onChange"] = (_event, selectedOption) => {
        if (typeof selectedOption?.value !== "string") {
            return;
        }

        void i18n.changeLanguage(selectedOption?.value).then(() => {
            // Force reload page to ensure translations load properly from i18next config file.
            // This is necessary because we use translations outside of components (in functions declared
            // outside components, and when declaring columns for TanStack Table library) without the useTranslation hook.
            window.location.reload();
        });
    };

    return (
        <SelectField
            disableSorting
            fullWidth={fullWidth}
            value={options.find((option) => option.value === currentLanguage)}
            options={options}
            onChange={onChange}
            {...(showLabel ? { label: t("pages:settingsPage.language.label") } : {})}
        />
    );
};

export default LanguageSwitcher;
